// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { ErrorInformationStorage } from '@shared/commons/ErrorInformationStorage';
import { Resources } from '@shared/localizations/Resources';
import { LinkedSystem } from '../misc/LinkedSystem';
import { Control } from '../elements/Control';
import { TerceraQuickTreeEvents } from '../elements/QuickTree/TerceraQuickTree';
import { TerceraLinkControlConstants } from '../UtilsClasses/TerceraLinkControlConstants';
import { EditPositionScreen } from '../screen/EditPositionScreen';
import { ModifyOrderScreen } from '../screen/ModifyOrderScreen';
import { MessageBoxType } from '@shared/utils/MessageBoxUtils';
import { TerceraMessageBox } from '../screen/TerceraMessageBox';
import { ApplicationPanelWithTable } from './ApplicationPanelWithTable';
import { DynProperty } from '@shared/commons/DynProperty';
import { ApplicationInfo } from '@shared/commons/ApplicationInfo';
import { TradingLockUtils } from '@shared/utils/TradingLockUtils';
import OrdersPanelBaseTemplate from '@front/templates/OrdersPanelBaseTemplate.html';
import { OrderItem } from '../cache/OrderItem';
import { IsAllowedResponce } from '@shared/commons/IsAllowed';
import { createTagDictionary } from '@shared/utils/ContextMenuUtils';
export class OrdersPanelBase extends ApplicationPanelWithTable {
    constructor() {
        super();
        this.updateCounter = 0;
        this.isFiltered = false;
        this.Name = 'OrdersPanelBase';
        this.ToolbarVisible = false;
    }
    isFilteredAction(action) {
        return false;
    }
    getDoubleClickActionParams() {
        return undefined;
    }
    getHotButtonPlacedFrom() {
        return undefined;
    }
    DCEventsSubscribe() { }
    DCEventsUnSubscribe() { }
    createMenuItems() {
        return [];
    }
    createTradingButtonItems() {
        return [];
    }
    updateAllowedActions() { }
    isClosingAction(action) {
        return false;
    }
    oninit() {
        super.oninit();
        this.updateAllowedActions = this.updateAllowedActions.bind(this);
    }
    oncomplete() {
        super.oncomplete();
        const qt = super.getQuickTable();
        const menuItems = this.createMenuItems();
        this.menuTagDict = createTagDictionary(menuItems);
        qt.setTableContextMenuItems(menuItems);
        qt.OnSelectionChanged.Subscribe(this.selectionChange, this);
        this.quickTableRactive.on(TerceraQuickTreeEvents.DoubleClick, this.onDoubleClicked.bind(this));
        const btns = this.Controls.btns;
        btns.setItemArray(this.createTradingButtonItems());
        btns.on('tradingAction', this.onTradingButtonClick.bind(this));
        if (this.DelayProperties) {
            btns.setBtnsVisibility(this.DelayProperties);
            this.DelayProperties = null;
        }
        this.UpdateToolbarVisibility(this.ToolbarVisible);
        this.localize();
        this.DCEventsSubscribe();
        this.updateAllowedActions();
        this.on('numericValueChanged', (context, value) => {
            void this.set('numericValue', value);
        });
    }
    getAccount() {
        const qt = super.getQuickTable();
        const rowItem = qt === null || qt === void 0 ? void 0 : qt.getSelectedTableItems()[0];
        if (rowItem) {
            return rowItem.GetCurrentAccount();
        }
        else {
            return undefined;
        }
    }
    action(action, confirm, placedFrom, numericLinkName) {
        if (TradingLockUtils.TradingLock.tradingLocked) {
            return false;
        }
        const quickTable = super.getQuickTable();
        if (isNullOrUndefined(quickTable)) {
            return false;
        }
        if (this.isClosingAction(action) && this.IsClosingForbidden(quickTable.selectedRowIds)) {
            return false;
        }
        return true;
    }
    TickAsync() {
        super.TickAsync();
        this.updateCounter++;
        if (this.updateCounter % 10 === 0) {
            this.updateAllowedActions();
            this.updateCounter = 0;
        }
    }
    ShowToolbarStateChange(menuItem) {
        this.UpdateToolbarVisibility(menuItem.checked);
    }
    UpdateToolbarVisibility(state) {
        void this.set('visibleContainerBtn', state);
        this.Controls.btns.set('visible', state);
        super.layoutTable();
        this.ToolbarVisible = state;
    }
    IsClosingAllowed(data) {
        return IsAllowedResponce.AllowedResponce();
    }
    IsClosingForbidden(selectedOrderIdArr) {
        const isAllowed = this.IsClosingAllowed(selectedOrderIdArr);
        if (isNullOrUndefined(isAllowed)) {
            return false;
        }
        if (isAllowed.Allowed) {
            return false;
        }
        const title = Resources.getResource('MessageBox.ThemeChanged.Title');
        const reason = isAllowed.ReasonText;
        TerceraMessageBox.Show(title, reason, MessageBoxType.Warning, null, null, false, true);
        return true;
    }
    onDoubleClicked() {
        if (this.isDoubleClickActionHidden()) {
            return;
        }
        const params = this.getDoubleClickActionParams();
        const quickTable = super.getQuickTable();
        if (isNullOrUndefined(quickTable)) {
            return;
        }
        const selectedOrderIdArr = quickTable.selectedRowIds;
        if (this.IsClosingForbidden(selectedOrderIdArr)) {
            return;
        }
        let screen = ModifyOrderScreen.getScreenByOrderID(selectedOrderIdArr[0]);
        if (isNullOrUndefined(screen)) {
            const qtItem = quickTable.getItemById(selectedOrderIdArr[0]);
            let posID;
            if ((qtItem === null || qtItem === void 0 ? void 0 : qtItem.item) instanceof OrderItem) {
                posID = qtItem.item.FOrder.PositionId;
            } // достаем PositionId
            screen = EditPositionScreen.getScreenByPositionID(posID); // чтобы найти открытый EditPositionScreen при клике на S/L(T/P) в панеле Working orders
        }
        if (!isNullOrUndefined(screen) && !screen.NotSkipNextTime) // TODO !!!
         {
            screen.NotSkipNextTime = true; // ЕБАНЫЙ КОСТЫЛЬ
            return;
        }
        const timerID = this.doubleClickedTimerID;
        if (timerID) {
            clearTimeout(timerID);
        }
        this.action(params.action, params.confirm, params.placedFrom, undefined);
    }
    onMouseDown(event, isHeader) {
        if (Control.IsEventProcessed(event)) {
            return;
        }
        const btns = this.Controls.btns;
        const offsetY = event.original.offsetY;
        if (offsetY <= 0 || offsetY >= 30 || !btns) {
            super.onMouseDown(event, isHeader);
            Control.ProcessEvent(event);
            return;
        }
        if (btns && !btns.get('visible'))
            return;
        btns.onMouseDown(event, isHeader);
    }
    onTradingButtonClick(context, action) {
        this.action(action, false, this.getHotButtonPlacedFrom(), undefined);
    }
    selectionChange() {
        const qt = super.getQuickTable();
        const selectedRowsId = qt.selectedRowIds;
        if (isNullOrUndefined(selectedRowsId))
            return;
        let insId = '';
        // let accId = ''
        if (selectedRowsId.length > 0) {
            const row = qt.rows[selectedRowsId[0]];
            const item = row ? row.item : null;
            if (item) {
                const ins = item.GetCurrentInstrument();
                if (ins)
                    insId = ins.GetInteriorID();
                // let acc = item.GetCurrentAccount()
                // if (acc) accId = acc.BstrAccount
            }
        }
        this.symbolLink_Out(false, insId);
        // this.accountLink_Out(false, accId)
        this.updateAllowedActions();
    }
    symbolLink_Out(newSubscriber, instrument) {
        if (!instrument) {
            return;
        }
        const color = super.get('symbolLinkValue');
        if (color !== TerceraLinkControlConstants.STATE_NONE) {
            LinkedSystem.setSymbol(color, instrument, newSubscriber);
        }
    }
    getSelectedInstrumentID() {
        const ins = super.getInstrument();
        let result = '';
        if (ins) {
            result = ins.GetInteriorID();
        }
        return result;
    }
    Properties() {
        const properties = super.Properties();
        const btns = this.Controls.btns;
        if (!isNullOrUndefined(btns)) {
            const btnProp = btns.getBtnsVisibility();
            properties.push(new DynProperty('BtnsVisibility', JSON.stringify(btnProp), DynProperty.STRING, DynProperty.HIDDEN_GROUP));
        }
        properties.push(new DynProperty('ToolbarVisible', this.ToolbarVisible, DynProperty.BOOLEAN, DynProperty.HIDDEN_GROUP));
        return properties;
    }
    callBack(newProperties) {
        super.callBack(newProperties);
        let btnsVisibility = DynProperty.getPropValue(newProperties, 'BtnsVisibility');
        if (btnsVisibility) {
            try {
                btnsVisibility = JSON.parse(btnsVisibility);
            }
            catch (ex) {
                ErrorInformationStorage.GetException(ex);
                btnsVisibility = [];
            }
            if (this.Controls.btns) {
                this.Controls.btns.setBtnsVisibility(btnsVisibility);
            }
            else {
                this.DelayProperties = btnsVisibility;
            }
        }
        const toolbarVisible = DynProperty.getPropValue(newProperties, 'ToolbarVisible');
        if (toolbarVisible != null) {
            this.ToolbarVisible = toolbarVisible;
        }
    }
    dispose() {
        super.dispose();
        this.DCEventsUnSubscribe();
    }
    isDoubleClickActionHidden() {
        return Resources.isHidden(`${this.headerLocaleKey}.doubleClickAvailability`); /* panel.orders.doubleClickAvailability, panel.positions.doubleClickAvailability */
    }
}
OrdersPanelBase.UPDATE_ALLOWED_ACTIONS_MILLIS = 500;
ApplicationPanelWithTable.extendWith(OrdersPanelBase, {
    data: function () {
        return {
            numericValue: 100,
            isAllowPadding: true,
            isAccountLinkShow: true,
            isSymbolLinkShow: true,
            isShowExploreTheAppLink: ApplicationInfo.isExploreMode
        };
    },
    partials: {
        bodyPartial: OrdersPanelBaseTemplate
    }
});
